import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { LangProvider } from './lib/i18n'
import './tokens.css'
import './shell.css'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('elemento #root não encontrado')

createRoot(root).render(
  <StrictMode>
    <LangProvider>
      <App />
    </LangProvider>
  </StrictMode>,
)

// Instalação do app na tela inicial e abertura sem sinal.
//
// Registrado DEPOIS da montagem e sem bloquear nada: se falhar, o app funciona
// igual — service worker é melhoria, não dependência. Só em produção, porque
// no vite dev ele serviria arquivos velhos e faria parecer que a edição não
// pegou.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => {
      console.warn('service worker não registrou:', e)
    })
  })
}
